import { defineMessages } from './define'

/* Home (patient and staff), the bookings list, one appointment, the ticket
 * button and a patient's own past visit. */

export default defineMessages({
  en: {
    'home.pNextAppt': 'Next appointment',
    'home.pInDays': 'In {n} days',
    'home.pViewBooking': 'View booking',
    'home.pReschedule': 'Reschedule',
    'home.pBookDoctor': 'Book a doctor',
    'home.pBookDoctorSub': 'Pick a doctor and a time',
    'home.pBookLabSub': 'Tests and their prices',
    'home.pMyLabs': 'My lab tests',
    'home.pRecentVisits': 'Recent visits',
    'home.pDiagnosis': 'Diagnosis:',
    'home.pViewRx': 'View prescription',
    'home.dWaitingHm': 'Waiting {h} h {m} min',
    'home.dTabQueue': 'Queue',
    'home.dTabReports': 'Reports',
    'home.dSchedule': "Today's schedule",
    'home.dBooked': "Booked today",
    'home.dSeen': "Seen",
    'home.dWaiting': "Waiting",
    'home.dNowServing': "Now serving",
    'home.dNextIn': "Next in",
    'home.dWaitingMin': "Waiting {n} mins",
    'home.dArrived': "Arrived: {time}",
    'home.dToken': "Token",
    'home.dComplaint': "Chief complaint",
    'home.dAllergy': "Allergy: {text}",
    'home.dOpenVisit': "Open visit",
    'home.dWaitingQueue': "Waiting queue",
    'home.dPatientsN': "({n} patients)",
    'home.dLiveRoom': "Live room",
    'home.dNoneWaiting': "No one else is waiting.",
    'home.rTabLab': 'Lab',
    'home.rGreet': "{greeting}, {name}",
    'home.rSearch': "Search patients",
    'home.rBookingsToday': "Bookings today",
    'home.rWaiting': "Waiting",
    'home.rCollected': "Collected",
    'home.rQuickActions': "Quick actions",
    'home.rBookAppt': "Book appointment",
    'home.rBookLab': "Book lab test",
    'home.rRegister': "Register patient",
    'home.rDayEnd': "Day end",
    'home.rTodaysDoctors': "Today's doctors",
    'home.rDoctorsN': "{n} doctors",
    'home.rBook': "Book",
    'home.rNextBookings': "Next bookings",
    'home.rAllBookings': "All bookings",
    // home
    'home.clinic': 'Clinic',
    'home.notifications': 'Notifications',
    'home.noDoctors': 'No doctors on the roster yet.',
    'home.hoursChanged': '{name} changed your hours: {what}',
    'home.hoursChangedMore': '{name} changed your hours: {what} (+{n} more)',
    'home.review': 'Review',
    'home.searchPatients': 'Search patients',
    'home.searchPh': 'Search patient by name, mobile or code',
    'home.quickActions': 'Quick actions',
    'home.console': 'Console',
    'home.labTests': 'Lab tests',
    'home.records': 'Records',
    'home.reports': 'Reports',
    'home.admin': 'Admin',
    'home.specialties': 'Specialties',
    'home.availableDoctors': 'Available Doctors',
    'home.upcomingAppointments': 'Upcoming Appointments',
    'home.loadingTodayBookings': 'Loading today’s bookings…',
    'home.nothingBookedToday': 'Nothing booked for the rest of today',
    'home.walkInsNote': 'Walk-ins still go through reception as usual.',
    'home.showingOf': 'Showing {shown} of {n} · See all {n}',
    'home.yourQueueTodayHead': 'Your Queue Today',
    'home.todaysQueue': 'Today’s Queue',
    'home.openDesk': 'Open the desk',
    'home.allLabBookings': 'All lab bookings',
    'home.doctorQueueCount': 'Doctor queue · {n}',
    'home.labTestsCount': 'Lab tests · {n}',
    'home.noVisitsToday': 'No visits opened yet today.',
    'home.nowAndWaiting': 'Now {token} · {n} waiting',
    'home.waitingCount': '{n} waiting',
    'home.nowSeeing': 'Now seeing {token}',
    'home.todayCount': '{n} today',
    'home.perConsultation': '/consultation',
    'home.viewProfile': 'View profile',
    'home.book': 'Book',
    'home.generalPractice': 'General practice',
    'home.yourQueueToday': 'Your queue today',
    'home.next': 'Next',
    'home.seenOf': '{done} of {total} seen',
    'home.resumeConsult': 'Resume consult',
    'home.callNext': 'Call next',
    'home.bookings': 'Bookings',
    'home.labDue': 'Due',
    'home.labDone': 'Done',
    'home.loadingTodayLabs': 'Loading today’s lab tests…',
    'home.noLabsToday': 'No lab tests booked for today.',
    'home.bookOne': 'Book one',
    'home.amountPaidShort': '{amount} paid',
    'home.amountDueShort': '{amount} due',

    // bookings
    'home.labCancelled': 'Lab test cancelled.',
    'home.couldNotCancelTest': 'Could not cancel the test.',
    'home.couldNotLoadLab': 'Could not load lab bookings.',
    'home.confirmedToast': 'Confirmed.',
    'home.markedNoShow': 'Marked no-show.',
    'home.alreadyCheckedIn': '{name} already has today\'s visit with this doctor - token #{token}.',
    'home.checkedIn': '{name} checked in - token #{token}.',
    'home.apptCancelled': 'Appointment cancelled.',
    'home.emptyAllHead': 'No appointments yet',
    'home.emptyAllBody': 'Book one from a doctor’s profile.',
    'home.emptyUpcomingHead': 'No upcoming appointments',
    'home.emptyUpcomingBody': 'Call the clinic to book one — the front desk takes appointments.',
    'home.emptyPastHead': 'No past appointments yet',
    'home.emptyPastBody': 'Visits you have completed will be listed here.',
    'home.emptyCancelledHead': 'Nothing cancelled',
    'home.emptyCancelledBody': 'Appointments that were cancelled or moved show up here.',
    'home.deskEmptyAllHead': 'No bookings on {date}',
    'home.deskEmptyTapDoctor': 'Tap a doctor below to book one.',
    'home.deskEmptyLiveHead': 'No live bookings on {date}',
    'home.deskEmptyDoneHead': 'Nothing finished on {date}',
    'home.deskEmptyDoneBody': 'Consultations move here once they are done.',
    'home.deskEmptyNotSeenHead': 'Nothing fell through on {date}',
    'home.deskEmptyNotSeenBody': 'Cancellations, no-shows and moved bookings land here.',
    'home.loadingYourAppts': 'Loading your appointments…',
    'home.consultationWith': 'Consultation with {doctor}',
    'home.paymentReceived': 'Payment received.',
    'home.pick': 'Pick',
    'home.jumpToDate': 'Jump to a date',
    'home.doctorBookings': 'Doctor bookings',
    'home.filterByDoctor': 'Filter by doctor',
    'home.allDoctors': 'All doctors',
    'home.bookWithOn': 'Book with {doctor} on {date}',
    'home.bookWithName': 'Book with {doctor}',
    'home.bookWith': 'Book with',
    'home.filterBookings': 'Filter bookings',
    'home.tabActive': 'Active',
    'home.tabDone': 'Done',
    'home.tabNotSeen': 'Not seen',
    'home.loadingBookings': 'Loading bookings…',
    'home.doctorBookingsAria': '{doctor} bookings',
    'home.bookingCount_one': '{n} booking',
    'home.bookingCount_other': '{n} bookings',
    'home.checkIn': 'Check in',
    'home.noShow': 'No-show',
    'home.bookedOn': '{n} booked · {date}',
    'home.doctorQueueAria': '{doctor} queue',
    'home.completedOf': '{done} of {total} completed',
    'home.loadingLabBookings': 'Loading lab bookings…',
    'home.labCollected': 'Collected',
    'home.noLabsOn': 'No lab tests on {date}',
    'home.labsBookedFromLab': 'Tests are booked from the Lab screen.',
    'home.labTest': 'Lab test',
    'home.labPill.sample_taken': 'sample taken',
    'home.labPill.completed': 'completed',
    'home.labPill.cancelled': 'cancelled',
    'home.sendTicket': 'Send ticket',
    'home.paidLower': 'paid',
    'home.unpaidLower': 'unpaid',

    // one appointment
    'home.channel.walk_in': 'Walk-in',
    'home.channel.phone': 'Phone',
    'home.channel.online': 'Online',
    'home.cancelReason.patientAsked': 'Patient asked to cancel',
    'home.cancelReason.patientUnwell': 'Patient is unwell',
    'home.cancelReason.doctorUnavailable': 'Doctor unavailable',
    'home.cancelReason.clinicClosed': 'Clinic closed that day',
    'home.cancelReason.mistake': 'Booked by mistake',
    'home.cancelReason.duplicate': 'Duplicate booking',
    'home.cancelReason.other': 'Other',
    'home.cancelWho': 'Cancel {name}?',
    'home.cancelNote': '{when} with {doctor}. The slot frees up; the record stays.',
    'home.sayWhatHappened': 'Say what happened',
    'home.cancelAppointment': 'Cancel appointment',
    'home.couldNotLoadAppt': 'Could not load the appointment.',
    'home.appointment': 'Appointment',
    'home.notOnListTitle': 'That booking is not on this list',
    'home.notOnListBody': 'It may sit on another day or another doctor.',
    'home.backToBookings': 'Back to bookings',
    'home.callPatient': 'Call patient',
    'home.missed': 'Missed',
    'home.allergyLine': 'Allergy: {allergies}',
    'home.bookedBy': 'Booked by',
    'home.payment': 'Payment',
    'home.paymentRef': 'Payment ref',
    'home.moved': 'Moved',
    'home.movedNote': 'This slot replaced an earlier booking that was moved.',
    'home.moveReason': 'Move reason',
    'home.cancelReasonLabel': 'Cancel reason',
    'home.missedPatient': 'This appointment\'s date has passed and you were not checked in. Book a new appointment if you still need to be seen.',
    'home.missedPatientCall': 'This appointment\'s date has passed and you were not checked in. Book a new appointment if you still need to be seen, or call the clinic on {phone}.',
    'home.livePatient': 'To move or cancel this appointment, use Move or Cancel on your Appointments list.',
    'home.livePatientCall': 'To move or cancel this appointment, use Move or Cancel on your Appointments list, or call the clinic on {phone}.',
    'home.closedPatient': 'This booking is {status}. Book a fresh appointment if you still need to be seen.',
    'home.dayPassedNoCheckin': 'This day passed without a check-in.',
    'home.markNoShow': 'Mark no-show',
    'home.closedStaff': 'This booking is {status} and cannot be stepped any further. Book a fresh appointment instead.',

    // a patient's own past visit
    'home.couldNotOpenVisit': 'Could not open this visit.',
    'home.notAvailable': 'Not available',
    'home.speciality': 'Speciality',
    'home.prescription': 'Prescription',
    'home.noRxYet': 'No prescription yet',
    'home.noRxBody': 'It appears here once the doctor has signed it.',
    'home.diagnosis': 'Diagnosis',
    'home.daysCount_one': '{n} day',
    'home.daysCount_other': '{n} days',
    'home.testsAdvised': 'Tests advised',
    'home.advice': 'Advice',
    'home.followUp': 'Follow-up',
    'home.inDays_one': 'in {n} day',
    'home.inDays_other': 'in {n} days',
    'home.signedBy': 'Signed {date} by {doctor}',
    'home.regNo': 'Reg. {no}',
    'home.receipt': 'Receipt',
    'home.noPayment': 'No payment recorded',
    'home.noPaymentBody': 'A receipt appears here once the fee is paid at the desk.',
    'home.payable': 'Payable',
    'home.paidOn': 'On',
  },
  hi: {
    'home.pNextAppt': 'अगली अपॉइंटमेंट',
    'home.pInDays': '{n} दिन में',
    'home.pViewBooking': 'बुकिंग देखें',
    'home.pReschedule': 'समय बदलें',
    'home.pBookDoctor': 'डॉक्टर बुक करें',
    'home.pBookDoctorSub': 'डॉक्टर और समय चुनें',
    'home.pBookLabSub': 'जाँच और उनकी कीमत',
    'home.pMyLabs': 'मेरी लैब जाँच',
    'home.pRecentVisits': 'हाल की विज़िट',
    'home.pDiagnosis': 'निदान:',
    'home.pViewRx': 'पर्चा देखें',
    'home.dWaitingHm': '{h} घं {m} मि से प्रतीक्षा',
    'home.dTabQueue': 'कतार',
    'home.dTabReports': 'रिपोर्ट',
    'home.dSchedule': "आज का शेड्यूल",
    'home.dBooked': "आज बुक",
    'home.dSeen': "देखे गए",
    'home.dWaiting': "प्रतीक्षा में",
    'home.dNowServing': "अभी देख रहे हैं",
    'home.dNextIn': "अगला मरीज़",
    'home.dWaitingMin': "{n} मिनट से प्रतीक्षा",
    'home.dArrived': "आए: {time}",
    'home.dToken': "टोकन",
    'home.dComplaint': "मुख्य शिकायत",
    'home.dAllergy': "एलर्जी: {text}",
    'home.dOpenVisit': "विज़िट खोलें",
    'home.dWaitingQueue': "प्रतीक्षा कतार",
    'home.dPatientsN': "({n} मरीज़)",
    'home.dLiveRoom': "परामर्श कक्ष",
    'home.dNoneWaiting': "और कोई प्रतीक्षा में नहीं है।",
    'home.rTabLab': 'लैब',
    'home.rGreet': "{greeting}, {name}",
    'home.rSearch': "मरीज़ खोजें",
    'home.rBookingsToday': "आज की बुकिंग",
    'home.rWaiting': "प्रतीक्षा में",
    'home.rCollected': "जमा",
    'home.rQuickActions': "त्वरित कार्य",
    'home.rBookAppt': "अपॉइंटमेंट बुक करें",
    'home.rBookLab': "लैब जाँच बुक करें",
    'home.rRegister': "मरीज़ पंजीकरण",
    'home.rDayEnd': "दिन का हिसाब",
    'home.rTodaysDoctors': "आज के डॉक्टर",
    'home.rDoctorsN': "{n} डॉक्टर",
    'home.rBook': "बुक करें",
    'home.rNextBookings': "अगली बुकिंग",
    'home.rAllBookings': "सभी बुकिंग",
    'home.clinic': 'क्लिनिक',
    'home.notifications': 'सूचनाएँ',
    'home.noDoctors': 'अभी कोई डॉक्टर सूची में नहीं है।',
    'home.hoursChanged': '{name} ने आपका समय बदला: {what}',
    'home.hoursChangedMore': '{name} ने आपका समय बदला: {what} (+{n} और)',
    'home.review': 'देखें',
    'home.searchPatients': 'मरीज़ खोजें',
    'home.searchPh': 'नाम, मोबाइल या कोड से मरीज़ खोजें',
    'home.quickActions': 'जल्दी पहुँचें',
    'home.console': 'कंसोल',
    'home.labTests': 'लैब टेस्ट',
    'home.records': 'रिकॉर्ड',
    'home.reports': 'रिपोर्ट',
    'home.admin': 'एडमिन',
    'home.specialties': 'विशेषज्ञता',
    'home.availableDoctors': 'उपलब्ध डॉक्टर',
    'home.upcomingAppointments': 'आगामी अपॉइंटमेंट',
    'home.loadingTodayBookings': 'आज की बुकिंग लोड हो रही हैं…',
    'home.nothingBookedToday': 'आज के बाकी दिन के लिए कोई बुकिंग नहीं',
    'home.walkInsNote': 'बिना बुकिंग आने वाले मरीज़ पहले की तरह रिसेप्शन से ही आएँगे।',
    'home.showingOf': '{n} में से {shown} दिख रही हैं · सभी {n} देखें',
    'home.yourQueueTodayHead': 'आज आपकी कतार',
    'home.todaysQueue': 'आज की कतार',
    'home.openDesk': 'डेस्क खोलें',
    'home.allLabBookings': 'सभी लैब बुकिंग',
    'home.doctorQueueCount': 'डॉक्टर की कतार · {n}',
    'home.labTestsCount': 'लैब टेस्ट · {n}',
    'home.noVisitsToday': 'आज अभी तक कोई विज़िट शुरू नहीं हुई।',
    'home.nowAndWaiting': 'अभी {token} · {n} इंतज़ार में',
    'home.waitingCount': '{n} इंतज़ार में',
    'home.nowSeeing': 'अभी {token} देख रहे हैं',
    'home.todayCount': 'आज {n}',
    'home.perConsultation': '/परामर्श',
    'home.viewProfile': 'प्रोफ़ाइल देखें',
    'home.book': 'बुक करें',
    'home.generalPractice': 'सामान्य चिकित्सा',
    'home.yourQueueToday': 'आज आपकी कतार',
    'home.next': 'अगला',
    'home.seenOf': '{total} में से {done} देखे गए',
    'home.resumeConsult': 'परामर्श जारी रखें',
    'home.callNext': 'अगले को बुलाएँ',
    'home.bookings': 'बुकिंग',
    'home.labDue': 'बाकी',
    'home.labDone': 'पूरा हुआ',
    'home.loadingTodayLabs': 'आज के लैब टेस्ट लोड हो रहे हैं…',
    'home.noLabsToday': 'आज के लिए कोई लैब टेस्ट बुक नहीं है।',
    'home.bookOne': 'बुक करें',
    'home.amountPaidShort': '{amount} भुगतान हो गया',
    'home.amountDueShort': '{amount} बाकी',

    'home.labCancelled': 'लैब टेस्ट रद्द हो गया।',
    'home.couldNotCancelTest': 'टेस्ट रद्द नहीं हो सका।',
    'home.couldNotLoadLab': 'लैब बुकिंग लोड नहीं हो सकीं।',
    'home.confirmedToast': 'पक्का हो गया।',
    'home.markedNoShow': '"नहीं आए" दर्ज किया गया।',
    'home.alreadyCheckedIn': '{name} की इस डॉक्टर के साथ आज की विज़िट पहले से है - टोकन #{token}।',
    'home.checkedIn': '{name} का चेक-इन हो गया - टोकन #{token}।',
    'home.apptCancelled': 'अपॉइंटमेंट रद्द हो गई।',
    'home.emptyAllHead': 'अभी कोई अपॉइंटमेंट नहीं',
    'home.emptyAllBody': 'किसी डॉक्टर की प्रोफ़ाइल से बुक करें।',
    'home.emptyUpcomingHead': 'कोई आगामी अपॉइंटमेंट नहीं',
    'home.emptyUpcomingBody': 'बुक करने के लिए क्लिनिक को फ़ोन करें — रिसेप्शन अपॉइंटमेंट बुक करता है।',
    'home.emptyPastHead': 'अभी कोई पिछली अपॉइंटमेंट नहीं',
    'home.emptyPastBody': 'आपकी पूरी हुई विज़िट यहाँ दिखेंगी।',
    'home.emptyCancelledHead': 'कुछ भी रद्द नहीं',
    'home.emptyCancelledBody': 'रद्द हुई या जिनका समय बदला गया, वे अपॉइंटमेंट यहाँ दिखेंगी।',
    'home.deskEmptyAllHead': '{date} को कोई बुकिंग नहीं',
    'home.deskEmptyTapDoctor': 'बुक करने के लिए नीचे किसी डॉक्टर पर टैप करें।',
    'home.deskEmptyLiveHead': '{date} को कोई चालू बुकिंग नहीं',
    'home.deskEmptyDoneHead': '{date} को कुछ पूरा नहीं हुआ',
    'home.deskEmptyDoneBody': 'परामर्श पूरा होने के बाद यहाँ आ जाता है।',
    'home.deskEmptyNotSeenHead': '{date} को कोई बुकिंग छूटी नहीं',
    'home.deskEmptyNotSeenBody': 'रद्द, "नहीं आए" और समय बदली गई बुकिंग यहाँ दिखती हैं।',
    'home.loadingYourAppts': 'आपकी अपॉइंटमेंट लोड हो रही हैं…',
    'home.consultationWith': '{doctor} के साथ परामर्श',
    'home.paymentReceived': 'भुगतान मिल गया।',
    'home.pick': 'चुनें',
    'home.jumpToDate': 'कोई तारीख चुनें',
    'home.doctorBookings': 'डॉक्टर बुकिंग',
    'home.filterByDoctor': 'डॉक्टर के अनुसार देखें',
    'home.allDoctors': 'सभी डॉक्टर',
    'home.bookWithOn': '{date} को {doctor} के साथ बुक करें',
    'home.bookWithName': '{doctor} के साथ बुक करें',
    'home.bookWith': 'इनके साथ बुक करें',
    'home.filterBookings': 'बुकिंग छाँटें',
    'home.tabActive': 'चालू',
    'home.tabDone': 'पूरी',
    'home.tabNotSeen': 'नहीं देखे गए',
    'home.loadingBookings': 'बुकिंग लोड हो रही हैं…',
    'home.doctorBookingsAria': '{doctor} की बुकिंग',
    'home.bookingCount_one': '{n} बुकिंग',
    'home.bookingCount_other': '{n} बुकिंग',
    'home.checkIn': 'चेक-इन करें',
    'home.noShow': 'नहीं आए',
    'home.bookedOn': '{n} बुक · {date}',
    'home.doctorQueueAria': '{doctor} की कतार',
    'home.completedOf': '{total} में से {done} पूरे',
    'home.loadingLabBookings': 'लैब बुकिंग लोड हो रही हैं…',
    'home.labCollected': 'सैंपल लिया गया',
    'home.noLabsOn': '{date} को कोई लैब टेस्ट नहीं',
    'home.labsBookedFromLab': 'टेस्ट लैब स्क्रीन से बुक होते हैं।',
    'home.labTest': 'लैब टेस्ट',
    'home.labPill.sample_taken': 'सैंपल लिया गया',
    'home.labPill.completed': 'पूरा हुआ',
    'home.labPill.cancelled': 'रद्द',
    'home.sendTicket': 'टिकट भेजें',
    'home.paidLower': 'भुगतान हो गया',
    'home.unpaidLower': 'भुगतान बाकी',

    'home.channel.walk_in': 'सीधे क्लिनिक आकर',
    'home.channel.phone': 'फ़ोन से',
    'home.channel.online': 'ऑनलाइन',
    'home.cancelReason.patientAsked': 'मरीज़ ने रद्द करने को कहा',
    'home.cancelReason.patientUnwell': 'मरीज़ की तबीयत ठीक नहीं',
    'home.cancelReason.doctorUnavailable': 'डॉक्टर उपलब्ध नहीं',
    'home.cancelReason.clinicClosed': 'उस दिन क्लिनिक बंद',
    'home.cancelReason.mistake': 'गलती से बुक हुई',
    'home.cancelReason.duplicate': 'दोहरी बुकिंग',
    'home.cancelReason.other': 'अन्य',
    'home.cancelWho': '{name} की बुकिंग रद्द करें?',
    'home.cancelNote': '{when}, {doctor} के साथ। समय खाली हो जाएगा; रिकॉर्ड बना रहेगा।',
    'home.sayWhatHappened': 'बताएँ क्या हुआ',
    'home.cancelAppointment': 'अपॉइंटमेंट रद्द करें',
    'home.couldNotLoadAppt': 'अपॉइंटमेंट लोड नहीं हो सकी।',
    'home.appointment': 'अपॉइंटमेंट',
    'home.notOnListTitle': 'यह बुकिंग इस सूची में नहीं है',
    'home.notOnListBody': 'हो सकता है यह किसी और दिन या किसी और डॉक्टर की हो।',
    'home.backToBookings': 'बुकिंग पर वापस जाएँ',
    'home.callPatient': 'मरीज़ को कॉल करें',
    'home.missed': 'छूट गई',
    'home.allergyLine': 'एलर्जी: {allergies}',
    'home.bookedBy': 'बुकिंग का तरीका',
    'home.payment': 'भुगतान',
    'home.paymentRef': 'भुगतान संदर्भ',
    'home.moved': 'समय बदला',
    'home.movedNote': 'यह समय पहले की एक बुकिंग की जगह है, जिसका समय बदला गया था।',
    'home.moveReason': 'समय बदलने का कारण',
    'home.cancelReasonLabel': 'रद्द करने का कारण',
    'home.missedPatient': 'इस अपॉइंटमेंट की तारीख निकल गई और आपका चेक-इन नहीं हुआ। अगर अब भी दिखाना है तो नई अपॉइंटमेंट बुक करें।',
    'home.missedPatientCall': 'इस अपॉइंटमेंट की तारीख निकल गई और आपका चेक-इन नहीं हुआ। अगर अब भी दिखाना है तो नई अपॉइंटमेंट बुक करें, या क्लिनिक को {phone} पर फ़ोन करें।',
    'home.livePatient': 'यह अपॉइंटमेंट बदलने या रद्द करने के लिए अपनी अपॉइंटमेंट सूची में "समय बदलें" या "रद्द करें" दबाएँ।',
    'home.livePatientCall': 'यह अपॉइंटमेंट बदलने या रद्द करने के लिए अपनी अपॉइंटमेंट सूची में "समय बदलें" या "रद्द करें" दबाएँ, या क्लिनिक को {phone} पर फ़ोन करें।',
    'home.closedPatient': 'यह बुकिंग {status} है। अगर अब भी दिखाना है तो नई अपॉइंटमेंट बुक करें।',
    'home.dayPassedNoCheckin': 'यह दिन बिना चेक-इन के निकल गया।',
    'home.markNoShow': '"नहीं आए" दर्ज करें',
    'home.closedStaff': 'यह बुकिंग {status} है, इसमें अब आगे कुछ नहीं किया जा सकता। इसकी जगह नई अपॉइंटमेंट बुक करें।',

    'home.couldNotOpenVisit': 'यह विज़िट खुल नहीं सकी।',
    'home.notAvailable': 'उपलब्ध नहीं',
    'home.speciality': 'विशेषज्ञता',
    'home.prescription': 'पर्चा',
    'home.noRxYet': 'अभी कोई पर्चा नहीं',
    'home.noRxBody': 'डॉक्टर के हस्ताक्षर करने के बाद यह यहाँ दिखेगा।',
    'home.diagnosis': 'निदान',
    'home.daysCount_one': '{n} दिन',
    'home.daysCount_other': '{n} दिन',
    'home.testsAdvised': 'सुझाए गए टेस्ट',
    'home.advice': 'सलाह',
    'home.followUp': 'फ़ॉलो-अप',
    'home.inDays_one': '{n} दिन बाद',
    'home.inDays_other': '{n} दिन बाद',
    'home.signedBy': '{date} को {doctor} ने हस्ताक्षर किए',
    'home.regNo': 'रजि. {no}',
    'home.receipt': 'रसीद',
    'home.noPayment': 'कोई भुगतान दर्ज नहीं',
    'home.noPaymentBody': 'डेस्क पर फ़ीस भरने के बाद रसीद यहाँ दिखेगी।',
    'home.payable': 'देय राशि',
    'home.paidOn': 'तारीख',
  },
  mr: {
    'home.pNextAppt': 'पुढील अपॉइंटमेंट',
    'home.pInDays': '{n} दिवसांत',
    'home.pViewBooking': 'बुकिंग पहा',
    'home.pReschedule': 'वेळ बदला',
    'home.pBookDoctor': 'डॉक्टर बुक करा',
    'home.pBookDoctorSub': 'डॉक्टर आणि वेळ निवडा',
    'home.pBookLabSub': 'तपासण्या आणि त्यांच्या किमती',
    'home.pMyLabs': 'माझ्या लॅब तपासण्या',
    'home.pRecentVisits': 'अलीकडील भेटी',
    'home.pDiagnosis': 'निदान:',
    'home.pViewRx': 'प्रिस्क्रिप्शन पहा',
    'home.dWaitingHm': '{h} ता {m} मि प्रतीक्षा',
    'home.dTabQueue': 'रांग',
    'home.dTabReports': 'अहवाल',
    'home.dSchedule': "आजचे वेळापत्रक",
    'home.dBooked': "आज बुक",
    'home.dSeen': "पाहिलेले",
    'home.dWaiting': "प्रतीक्षेत",
    'home.dNowServing': "आता तपासत आहे",
    'home.dNextIn': "पुढील रुग्ण",
    'home.dWaitingMin': "{n} मिनिटे प्रतीक्षा",
    'home.dArrived': "आले: {time}",
    'home.dToken': "टोकन",
    'home.dComplaint': "मुख्य तक्रार",
    'home.dAllergy': "ॲलर्जी: {text}",
    'home.dOpenVisit': "भेट उघडा",
    'home.dWaitingQueue': "प्रतीक्षा रांग",
    'home.dPatientsN': "({n} रुग्ण)",
    'home.dLiveRoom': "तपासणी कक्ष",
    'home.dNoneWaiting': "आणखी कोणी प्रतीक्षेत नाही.",
    'home.rTabLab': 'लॅब',
    'home.rGreet': "{greeting}, {name}",
    'home.rSearch': "रुग्ण शोधा",
    'home.rBookingsToday': "आजच्या बुकिंग",
    'home.rWaiting': "प्रतीक्षेत",
    'home.rCollected': "जमा",
    'home.rQuickActions': "झटपट कामे",
    'home.rBookAppt': "अपॉइंटमेंट बुक करा",
    'home.rBookLab': "लॅब तपासणी बुक करा",
    'home.rRegister': "रुग्ण नोंदणी",
    'home.rDayEnd': "दिवसाचा हिशोब",
    'home.rTodaysDoctors': "आजचे डॉक्टर",
    'home.rDoctorsN': "{n} डॉक्टर",
    'home.rBook': "बुक करा",
    'home.rNextBookings': "पुढील बुकिंग",
    'home.rAllBookings': "सर्व बुकिंग",
    'home.clinic': 'क्लिनिक',
    'home.notifications': 'सूचना',
    'home.noDoctors': 'अजून यादीत कोणतेही डॉक्टर नाहीत.',
    'home.hoursChanged': '{name} यांनी तुमची वेळ बदलली: {what}',
    'home.hoursChangedMore': '{name} यांनी तुमची वेळ बदलली: {what} (+{n} आणखी)',
    'home.review': 'पाहा',
    'home.searchPatients': 'रुग्ण शोधा',
    'home.searchPh': 'नाव, मोबाइल किंवा कोडने रुग्ण शोधा',
    'home.quickActions': 'झटपट पर्याय',
    'home.console': 'कन्सोल',
    'home.labTests': 'लॅब तपासण्या',
    'home.records': 'रेकॉर्ड',
    'home.reports': 'रिपोर्ट',
    'home.admin': 'ॲडमिन',
    'home.specialties': 'विशेषता',
    'home.availableDoctors': 'उपलब्ध डॉक्टर',
    'home.upcomingAppointments': 'पुढील अपॉइंटमेंट',
    'home.loadingTodayBookings': 'आजच्या बुकिंग लोड होत आहेत…',
    'home.nothingBookedToday': 'आज उरलेल्या दिवसासाठी कोणतीही बुकिंग नाही',
    'home.walkInsNote': 'बुकिंगशिवाय येणारे रुग्ण नेहमीप्रमाणे रिसेप्शनमधूनच येतील.',
    'home.showingOf': '{n} पैकी {shown} दाखवत आहे · सर्व {n} पाहा',
    'home.yourQueueTodayHead': 'आज तुमची रांग',
    'home.todaysQueue': 'आजची रांग',
    'home.openDesk': 'डेस्क उघडा',
    'home.allLabBookings': 'सर्व लॅब बुकिंग',
    'home.doctorQueueCount': 'डॉक्टरांची रांग · {n}',
    'home.labTestsCount': 'लॅब तपासण्या · {n}',
    'home.noVisitsToday': 'आज अजून कोणतीही भेट सुरू झालेली नाही.',
    'home.nowAndWaiting': 'सध्या {token} · {n} प्रतीक्षेत',
    'home.waitingCount': '{n} प्रतीक्षेत',
    'home.nowSeeing': 'सध्या {token} तपासत आहेत',
    'home.todayCount': 'आज {n}',
    'home.perConsultation': '/तपासणी',
    'home.viewProfile': 'प्रोफाइल पाहा',
    'home.book': 'बुक करा',
    'home.generalPractice': 'सामान्य उपचार',
    'home.yourQueueToday': 'आज तुमची रांग',
    'home.next': 'पुढील',
    'home.seenOf': '{total} पैकी {done} तपासले',
    'home.resumeConsult': 'तपासणी पुन्हा सुरू करा',
    'home.callNext': 'पुढच्याला बोलवा',
    'home.bookings': 'बुकिंग',
    'home.labDue': 'बाकी',
    'home.labDone': 'पूर्ण',
    'home.loadingTodayLabs': 'आजच्या लॅब तपासण्या लोड होत आहेत…',
    'home.noLabsToday': 'आजसाठी कोणतीही लॅब तपासणी बुक नाही.',
    'home.bookOne': 'बुक करा',
    'home.amountPaidShort': '{amount} भरले',
    'home.amountDueShort': '{amount} बाकी',

    'home.labCancelled': 'लॅब तपासणी रद्द झाली.',
    'home.couldNotCancelTest': 'तपासणी रद्द करता आली नाही.',
    'home.couldNotLoadLab': 'लॅब बुकिंग लोड झाल्या नाहीत.',
    'home.confirmedToast': 'निश्चित झाले.',
    'home.markedNoShow': '"आले नाहीत" अशी नोंद केली.',
    'home.alreadyCheckedIn': '{name} यांची या डॉक्टरांकडे आजची भेट आधीच आहे - टोकन #{token}.',
    'home.checkedIn': '{name} यांचे चेक-इन झाले - टोकन #{token}.',
    'home.apptCancelled': 'अपॉइंटमेंट रद्द झाली.',
    'home.emptyAllHead': 'अजून कोणतीही अपॉइंटमेंट नाही',
    'home.emptyAllBody': 'डॉक्टरांच्या प्रोफाइलवरून बुक करा.',
    'home.emptyUpcomingHead': 'पुढील कोणतीही अपॉइंटमेंट नाही',
    'home.emptyUpcomingBody': 'बुक करण्यासाठी क्लिनिकला फोन करा — रिसेप्शन अपॉइंटमेंट बुक करते.',
    'home.emptyPastHead': 'अजून कोणतीही मागील अपॉइंटमेंट नाही',
    'home.emptyPastBody': 'तुमच्या पूर्ण झालेल्या भेटी इथे दिसतील.',
    'home.emptyCancelledHead': 'काहीही रद्द नाही',
    'home.emptyCancelledBody': 'रद्द झालेल्या किंवा वेळ बदललेल्या अपॉइंटमेंट इथे दिसतात.',
    'home.deskEmptyAllHead': '{date} रोजी कोणतीही बुकिंग नाही',
    'home.deskEmptyTapDoctor': 'बुक करण्यासाठी खालील डॉक्टरांवर टॅप करा.',
    'home.deskEmptyLiveHead': '{date} रोजी कोणतीही चालू बुकिंग नाही',
    'home.deskEmptyDoneHead': '{date} रोजी काहीही पूर्ण झाले नाही',
    'home.deskEmptyDoneBody': 'तपासणी पूर्ण झाल्यावर ती इथे येते.',
    'home.deskEmptyNotSeenHead': '{date} रोजी कोणतीही बुकिंग चुकली नाही',
    'home.deskEmptyNotSeenBody': 'रद्द, "आले नाहीत" आणि वेळ बदललेल्या बुकिंग इथे दिसतात.',
    'home.loadingYourAppts': 'तुमच्या अपॉइंटमेंट लोड होत आहेत…',
    'home.consultationWith': '{doctor} यांच्याकडे तपासणी',
    'home.paymentReceived': 'पैसे मिळाले.',
    'home.pick': 'निवडा',
    'home.jumpToDate': 'तारीख निवडा',
    'home.doctorBookings': 'डॉक्टर बुकिंग',
    'home.filterByDoctor': 'डॉक्टरनुसार पाहा',
    'home.allDoctors': 'सर्व डॉक्टर',
    'home.bookWithOn': '{date} रोजी {doctor} यांच्याकडे बुक करा',
    'home.bookWithName': '{doctor} यांच्याकडे बुक करा',
    'home.bookWith': 'यांच्याकडे बुक करा',
    'home.filterBookings': 'बुकिंग निवडा',
    'home.tabActive': 'चालू',
    'home.tabDone': 'पूर्ण',
    'home.tabNotSeen': 'तपासले नाही',
    'home.loadingBookings': 'बुकिंग लोड होत आहेत…',
    'home.doctorBookingsAria': '{doctor} यांच्या बुकिंग',
    'home.bookingCount_one': '{n} बुकिंग',
    'home.bookingCount_other': '{n} बुकिंग',
    'home.checkIn': 'चेक-इन करा',
    'home.noShow': 'आले नाहीत',
    'home.bookedOn': '{n} बुक · {date}',
    'home.doctorQueueAria': '{doctor} यांची रांग',
    'home.completedOf': '{total} पैकी {done} पूर्ण',
    'home.loadingLabBookings': 'लॅब बुकिंग लोड होत आहेत…',
    'home.labCollected': 'नमुना घेतला',
    'home.noLabsOn': '{date} रोजी कोणतीही लॅब तपासणी नाही',
    'home.labsBookedFromLab': 'तपासण्या लॅब स्क्रीनवरून बुक होतात.',
    'home.labTest': 'लॅब तपासणी',
    'home.labPill.sample_taken': 'नमुना घेतला',
    'home.labPill.completed': 'पूर्ण',
    'home.labPill.cancelled': 'रद्द',
    'home.sendTicket': 'तिकीट पाठवा',
    'home.paidLower': 'भरले',
    'home.unpaidLower': 'बाकी',

    'home.channel.walk_in': 'थेट क्लिनिकमध्ये येऊन',
    'home.channel.phone': 'फोनवरून',
    'home.channel.online': 'ऑनलाइन',
    'home.cancelReason.patientAsked': 'रुग्णाने रद्द करायला सांगितले',
    'home.cancelReason.patientUnwell': 'रुग्णाची तब्येत बरी नाही',
    'home.cancelReason.doctorUnavailable': 'डॉक्टर उपलब्ध नाहीत',
    'home.cancelReason.clinicClosed': 'त्या दिवशी क्लिनिक बंद',
    'home.cancelReason.mistake': 'चुकून बुक झाली',
    'home.cancelReason.duplicate': 'दुहेरी बुकिंग',
    'home.cancelReason.other': 'इतर',
    'home.cancelWho': '{name} यांची बुकिंग रद्द करायची?',
    'home.cancelNote': '{when}, {doctor} यांच्याकडे. वेळ मोकळी होईल; नोंद तशीच राहील.',
    'home.sayWhatHappened': 'काय झाले ते लिहा',
    'home.cancelAppointment': 'अपॉइंटमेंट रद्द करा',
    'home.couldNotLoadAppt': 'अपॉइंटमेंट लोड झाली नाही.',
    'home.appointment': 'अपॉइंटमेंट',
    'home.notOnListTitle': 'ही बुकिंग या यादीत नाही',
    'home.notOnListBody': 'ती दुसऱ्या दिवशीची किंवा दुसऱ्या डॉक्टरांची असू शकते.',
    'home.backToBookings': 'बुकिंगकडे परत जा',
    'home.callPatient': 'रुग्णाला कॉल करा',
    'home.missed': 'चुकली',
    'home.allergyLine': 'ॲलर्जी: {allergies}',
    'home.bookedBy': 'बुकिंग कशी झाली',
    'home.payment': 'पेमेंट',
    'home.paymentRef': 'पेमेंट संदर्भ',
    'home.moved': 'वेळ बदलली',
    'home.movedNote': 'ही वेळ आधीच्या एका बुकिंगच्या जागी आहे, जिची वेळ बदलली होती.',
    'home.moveReason': 'वेळ बदलण्याचे कारण',
    'home.cancelReasonLabel': 'रद्द करण्याचे कारण',
    'home.missedPatient': 'या अपॉइंटमेंटची तारीख उलटून गेली आणि तुमचे चेक-इन झाले नाही. अजूनही डॉक्टरांना दाखवायचे असल्यास नवीन अपॉइंटमेंट बुक करा.',
    'home.missedPatientCall': 'या अपॉइंटमेंटची तारीख उलटून गेली आणि तुमचे चेक-इन झाले नाही. अजूनही डॉक्टरांना दाखवायचे असल्यास नवीन अपॉइंटमेंट बुक करा, किंवा क्लिनिकला {phone} वर फोन करा.',
    'home.livePatient': 'ही अपॉइंटमेंट बदलण्यासाठी किंवा रद्द करण्यासाठी तुमच्या अपॉइंटमेंट यादीतील "वेळ बदला" किंवा "रद्द करा" वापरा.',
    'home.livePatientCall': 'ही अपॉइंटमेंट बदलण्यासाठी किंवा रद्द करण्यासाठी तुमच्या अपॉइंटमेंट यादीतील "वेळ बदला" किंवा "रद्द करा" वापरा, किंवा क्लिनिकला {phone} वर फोन करा.',
    'home.closedPatient': 'ही बुकिंग {status} आहे. अजूनही डॉक्टरांना दाखवायचे असल्यास नवीन अपॉइंटमेंट बुक करा.',
    'home.dayPassedNoCheckin': 'हा दिवस चेक-इन न होता गेला.',
    'home.markNoShow': '"आले नाहीत" अशी नोंद करा',
    'home.closedStaff': 'ही बुकिंग {status} आहे, त्यात आता पुढे काही करता येणार नाही. त्याऐवजी नवीन अपॉइंटमेंट बुक करा.',

    'home.couldNotOpenVisit': 'ही भेट उघडता आली नाही.',
    'home.notAvailable': 'उपलब्ध नाही',
    'home.speciality': 'विशेषता',
    'home.prescription': 'प्रिस्क्रिप्शन',
    'home.noRxYet': 'अजून प्रिस्क्रिप्शन नाही',
    'home.noRxBody': 'डॉक्टरांनी सही केल्यावर ते इथे दिसेल.',
    'home.diagnosis': 'निदान',
    'home.daysCount_one': '{n} दिवस',
    'home.daysCount_other': '{n} दिवस',
    'home.testsAdvised': 'सुचवलेल्या तपासण्या',
    'home.advice': 'सल्ला',
    'home.followUp': 'फॉलो-अप',
    'home.inDays_one': '{n} दिवसांनी',
    'home.inDays_other': '{n} दिवसांनी',
    'home.signedBy': '{date} रोजी {doctor} यांनी सही केली',
    'home.regNo': 'नोंदणी क्र. {no}',
    'home.receipt': 'पावती',
    'home.noPayment': 'कोणतेही पेमेंट नोंदवलेले नाही',
    'home.noPaymentBody': 'डेस्कवर फी भरल्यावर पावती इथे दिसेल.',
    'home.payable': 'भरायची रक्कम',
    'home.paidOn': 'दिनांक',
  },
  or: {
    'home.pNextAppt': 'ପରବର୍ତ୍ତୀ ଆପଏଣ୍ଟମେଣ୍ଟ',
    'home.pInDays': '{n} ଦିନରେ',
    'home.pViewBooking': 'ବୁକିଂ ଦେଖନ୍ତୁ',
    'home.pReschedule': 'ସମୟ ବଦଳାନ୍ତୁ',
    'home.pBookDoctor': 'ଡାକ୍ତର ବୁକ୍',
    'home.pBookDoctorSub': 'ଡାକ୍ତର ଓ ସମୟ ବାଛନ୍ତୁ',
    'home.pBookLabSub': 'ପରୀକ୍ଷା ଓ ଦାମ୍',
    'home.pMyLabs': 'ମୋର ଲ୍ୟାବ୍ ପରୀକ୍ଷା',
    'home.pRecentVisits': 'ସାମ୍ପ୍ରତିକ ଭିଜିଟ୍',
    'home.pDiagnosis': 'ନିଦାନ:',
    'home.pViewRx': 'ପ୍ରେସକ୍ରିପସନ୍ ଦେଖନ୍ତୁ',
    'home.dWaitingHm': '{h} ଘଣ୍ଟା {m} ମିନିଟ୍ ଅପେକ୍ଷା',
    'home.dTabQueue': 'ଧାଡ଼ି',
    'home.dTabReports': 'ରିପୋର୍ଟ',
    'home.dSchedule': "ଆଜିର ସୂଚୀ",
    'home.dBooked': "ଆଜି ବୁକ୍",
    'home.dSeen': "ଦେଖାଯାଇଛି",
    'home.dWaiting': "ଅପେକ୍ଷାରେ",
    'home.dNowServing': "ଏବେ ଦେଖୁଛନ୍ତି",
    'home.dNextIn': "ପରବର୍ତ୍ତୀ ରୋଗୀ",
    'home.dWaitingMin': "{n} ମିନିଟ୍ ଅପେକ୍ଷା",
    'home.dArrived': "ଆସିଲେ: {time}",
    'home.dToken': "ଟୋକେନ୍",
    'home.dComplaint': "ମୁଖ୍ୟ ଅଭିଯୋଗ",
    'home.dAllergy': "ଆଲର୍ଜି: {text}",
    'home.dOpenVisit': "ଭିଜିଟ୍ ଖୋଲନ୍ତୁ",
    'home.dWaitingQueue': "ଅପେକ୍ଷା ଧାଡ଼ି",
    'home.dPatientsN': "({n} ରୋଗୀ)",
    'home.dLiveRoom': "ପରାମର୍ଶ କକ୍ଷ",
    'home.dNoneWaiting': "ଆଉ କେହି ଅପେକ୍ଷାରେ ନାହାନ୍ତି।",
    'home.rTabLab': 'ଲ୍ୟାବ୍',
    'home.rGreet': "{greeting}, {name}",
    'home.rSearch': "ରୋଗୀ ଖୋଜନ୍ତୁ",
    'home.rBookingsToday': "ଆଜିର ବୁକିଂ",
    'home.rWaiting': "ଅପେକ୍ଷାରେ",
    'home.rCollected': "ଜମା",
    'home.rQuickActions': "ଶୀଘ୍ର କାର୍ଯ୍ୟ",
    'home.rBookAppt': "ଆପଏଣ୍ଟମେଣ୍ଟ ବୁକ୍",
    'home.rBookLab': "ଲ୍ୟାବ୍ ପରୀକ୍ଷା ବୁକ୍",
    'home.rRegister': "ରୋଗୀ ପଞ୍ଜୀକରଣ",
    'home.rDayEnd': "ଦିନ ଶେଷ",
    'home.rTodaysDoctors': "ଆଜିର ଡାକ୍ତର",
    'home.rDoctorsN': "{n} ଡାକ୍ତର",
    'home.rBook': "ବୁକ୍",
    'home.rNextBookings': "ପରବର୍ତ୍ତୀ ବୁକିଂ",
    'home.rAllBookings': "ସମସ୍ତ ବୁକିଂ",
    'home.clinic': 'କ୍ଲିନିକ୍',
    'home.notifications': 'ସୂଚନା',
    'home.noDoctors': 'ତାଲିକାରେ ଏପର୍ଯ୍ୟନ୍ତ କୌଣସି ଡାକ୍ତର ନାହାଁନ୍ତି।',
    'home.hoursChanged': '{name} ଆପଣଙ୍କ ସମୟ ବଦଳାଇଛନ୍ତି: {what}',
    'home.hoursChangedMore': '{name} ଆପଣଙ୍କ ସମୟ ବଦଳାଇଛନ୍ତି: {what} (+{n} ଅଧିକ)',
    'home.review': 'ଦେଖନ୍ତୁ',
    'home.searchPatients': 'ରୋଗୀ ଖୋଜନ୍ତୁ',
    'home.searchPh': 'ନାମ, ମୋବାଇଲ୍ କିମ୍ବା କୋଡ୍ ଦ୍ୱାରା ରୋଗୀ ଖୋଜନ୍ତୁ',
    'home.quickActions': 'ଶୀଘ୍ର ବିକଳ୍ପ',
    'home.console': 'କନସୋଲ୍',
    'home.labTests': 'ଲ୍ୟାବ୍ ପରୀକ୍ଷା',
    'home.records': 'ରେକର୍ଡ',
    'home.reports': 'ରିପୋର୍ଟ',
    'home.admin': 'ଆଡମିନ୍',
    'home.specialties': 'ବିଶେଷଜ୍ଞତା',
    'home.availableDoctors': 'ଉପଲବ୍ଧ ଡାକ୍ତର',
    'home.upcomingAppointments': 'ଆଗାମୀ ଆପଏଣ୍ଟମେଣ୍ଟ',
    'home.loadingTodayBookings': 'ଆଜିର ବୁକିଂ ଲୋଡ୍ ହେଉଛି…',
    'home.nothingBookedToday': 'ଆଜି ବାକି ଦିନ ପାଇଁ କୌଣସି ବୁକିଂ ନାହିଁ',
    'home.walkInsNote': 'ବୁକିଂ ବିନା ଆସୁଥିବା ରୋଗୀ ପୂର୍ବ ପରି ରିସେପ୍ସନ୍ ଦେଇ ଆସିବେ।',
    'home.showingOf': '{n} ମଧ୍ୟରୁ {shown} ଦେଖାଯାଉଛି · ସବୁ {n} ଦେଖନ୍ତୁ',
    'home.yourQueueTodayHead': 'ଆଜି ଆପଣଙ୍କ ଧାଡ଼ି',
    'home.todaysQueue': 'ଆଜିର ଧାଡ଼ି',
    'home.openDesk': 'ଡେସ୍କ ଖୋଲନ୍ତୁ',
    'home.allLabBookings': 'ସବୁ ଲ୍ୟାବ୍ ବୁକିଂ',
    'home.doctorQueueCount': 'ଡାକ୍ତରଙ୍କ ଧାଡ଼ି · {n}',
    'home.labTestsCount': 'ଲ୍ୟାବ୍ ପରୀକ୍ଷା · {n}',
    'home.noVisitsToday': 'ଆଜି ଏପର୍ଯ୍ୟନ୍ତ କୌଣସି ପରିଦର୍ଶନ ଆରମ୍ଭ ହୋଇନାହିଁ।',
    'home.nowAndWaiting': 'ବର୍ତ୍ତମାନ {token} · {n} ଅପେକ୍ଷାରେ',
    'home.waitingCount': '{n} ଅପେକ୍ଷାରେ',
    'home.nowSeeing': 'ବର୍ତ୍ତମାନ {token} ଦେଖୁଛନ୍ତି',
    'home.todayCount': 'ଆଜି {n}',
    'home.perConsultation': '/ପରାମର୍ଶ',
    'home.viewProfile': 'ପ୍ରୋଫାଇଲ୍ ଦେଖନ୍ତୁ',
    'home.book': 'ବୁକ୍ କରନ୍ତୁ',
    'home.generalPractice': 'ସାଧାରଣ ଚିକିତ୍ସା',
    'home.yourQueueToday': 'ଆଜି ଆପଣଙ୍କ ଧାଡ଼ି',
    'home.next': 'ପରବର୍ତ୍ତୀ',
    'home.seenOf': '{total} ମଧ୍ୟରୁ {done} ଦେଖାଗଲା',
    'home.resumeConsult': 'ପରାମର୍ଶ ଜାରି ରଖନ୍ତୁ',
    'home.callNext': 'ପରବର୍ତ୍ତୀଙ୍କୁ ଡାକନ୍ତୁ',
    'home.bookings': 'ବୁକିଂ',
    'home.labDue': 'ବାକି',
    'home.labDone': 'ସମ୍ପୂର୍ଣ୍ଣ',
    'home.loadingTodayLabs': 'ଆଜିର ଲ୍ୟାବ୍ ପରୀକ୍ଷା ଲୋଡ୍ ହେଉଛି…',
    'home.noLabsToday': 'ଆଜି ପାଇଁ କୌଣସି ଲ୍ୟାବ୍ ପରୀକ୍ଷା ବୁକ୍ ହୋଇନାହିଁ।',
    'home.bookOne': 'ବୁକ୍ କରନ୍ତୁ',
    'home.amountPaidShort': '{amount} ଦେୟ ଦିଆଗଲା',
    'home.amountDueShort': '{amount} ବାକି',

    'home.labCancelled': 'ଲ୍ୟାବ୍ ପରୀକ୍ଷା ବାତିଲ୍ ହେଲା।',
    'home.couldNotCancelTest': 'ପରୀକ୍ଷା ବାତିଲ୍ କରାଯାଇପାରିଲା ନାହିଁ।',
    'home.couldNotLoadLab': 'ଲ୍ୟାବ୍ ବୁକିଂ ଲୋଡ୍ ହୋଇପାରିଲା ନାହିଁ।',
    'home.confirmedToast': 'ନିଶ୍ଚିତ ହେଲା।',
    'home.markedNoShow': '"ଆସିଲେ ନାହିଁ" ଲେଖାଗଲା।',
    'home.alreadyCheckedIn': 'ଏହି ଡାକ୍ତରଙ୍କ ସହ {name}ଙ୍କ ଆଜିର ପରିଦର୍ଶନ ପୂର୍ବରୁ ଅଛି - ଟୋକେନ୍ #{token}।',
    'home.checkedIn': '{name}ଙ୍କ ଚେକ୍-ଇନ୍ ହେଲା - ଟୋକେନ୍ #{token}।',
    'home.apptCancelled': 'ଆପଏଣ୍ଟମେଣ୍ଟ ବାତିଲ୍ ହେଲା।',
    'home.emptyAllHead': 'ଏପର୍ଯ୍ୟନ୍ତ କୌଣସି ଆପଏଣ୍ଟମେଣ୍ଟ ନାହିଁ',
    'home.emptyAllBody': 'ଡାକ୍ତରଙ୍କ ପ୍ରୋଫାଇଲରୁ ବୁକ୍ କରନ୍ତୁ।',
    'home.emptyUpcomingHead': 'କୌଣସି ଆଗାମୀ ଆପଏଣ୍ଟମେଣ୍ଟ ନାହିଁ',
    'home.emptyUpcomingBody': 'ବୁକ୍ କରିବାକୁ କ୍ଲିନିକ୍‌କୁ ଫୋନ୍ କରନ୍ତୁ — ରିସେପ୍ସନ୍ ଆପଏଣ୍ଟମେଣ୍ଟ ବୁକ୍ କରେ।',
    'home.emptyPastHead': 'ଏପର୍ଯ୍ୟନ୍ତ କୌଣସି ପୂର୍ବ ଆପଏଣ୍ଟମେଣ୍ଟ ନାହିଁ',
    'home.emptyPastBody': 'ଆପଣଙ୍କ ସମ୍ପୂର୍ଣ୍ଣ ହୋଇଥିବା ପରିଦର୍ଶନ ଏଠାରେ ଦେଖାଯିବ।',
    'home.emptyCancelledHead': 'କିଛି ବାତିଲ୍ ହୋଇନାହିଁ',
    'home.emptyCancelledBody': 'ବାତିଲ୍ ହୋଇଥିବା କିମ୍ବା ସମୟ ବଦଳିଥିବା ଆପଏଣ୍ଟମେଣ୍ଟ ଏଠାରେ ଦେଖାଯାଏ।',
    'home.deskEmptyAllHead': '{date}ରେ କୌଣସି ବୁକିଂ ନାହିଁ',
    'home.deskEmptyTapDoctor': 'ବୁକ୍ କରିବାକୁ ତଳେ ଜଣେ ଡାକ୍ତରଙ୍କ ଉପରେ ଟ୍ୟାପ୍ କରନ୍ତୁ।',
    'home.deskEmptyLiveHead': '{date}ରେ କୌଣସି ଚାଲୁ ବୁକିଂ ନାହିଁ',
    'home.deskEmptyDoneHead': '{date}ରେ କିଛି ସମ୍ପୂର୍ଣ୍ଣ ହୋଇନାହିଁ',
    'home.deskEmptyDoneBody': 'ପରାମର୍ଶ ସମ୍ପୂର୍ଣ୍ଣ ହେବା ପରେ ଏଠାକୁ ଆସେ।',
    'home.deskEmptyNotSeenHead': '{date}ରେ କୌଣସି ବୁକିଂ ଛାଡ଼ି ଯାଇନାହିଁ',
    'home.deskEmptyNotSeenBody': 'ବାତିଲ୍, "ଆସିଲେ ନାହିଁ" ଓ ସମୟ ବଦଳିଥିବା ବୁକିଂ ଏଠାରେ ଦେଖାଯାଏ।',
    'home.loadingYourAppts': 'ଆପଣଙ୍କ ଆପଏଣ୍ଟମେଣ୍ଟ ଲୋଡ୍ ହେଉଛି…',
    'home.consultationWith': '{doctor}ଙ୍କ ସହ ପରାମର୍ଶ',
    'home.paymentReceived': 'ଦେୟ ମିଳିଗଲା।',
    'home.pick': 'ବାଛନ୍ତୁ',
    'home.jumpToDate': 'ଏକ ତାରିଖ ବାଛନ୍ତୁ',
    'home.doctorBookings': 'ଡାକ୍ତର ବୁକିଂ',
    'home.filterByDoctor': 'ଡାକ୍ତର ଅନୁଯାୟୀ ଦେଖନ୍ତୁ',
    'home.allDoctors': 'ସବୁ ଡାକ୍ତର',
    'home.bookWithOn': '{date}ରେ {doctor}ଙ୍କ ସହ ବୁକ୍ କରନ୍ତୁ',
    'home.bookWithName': '{doctor}ଙ୍କ ସହ ବୁକ୍ କରନ୍ତୁ',
    'home.bookWith': 'ଏମାନଙ୍କ ସହ ବୁକ୍ କରନ୍ତୁ',
    'home.filterBookings': 'ବୁକିଂ ବାଛନ୍ତୁ',
    'home.tabActive': 'ଚାଲୁ',
    'home.tabDone': 'ସମ୍ପୂର୍ଣ୍ଣ',
    'home.tabNotSeen': 'ଦେଖାଯାଇନାହିଁ',
    'home.loadingBookings': 'ବୁକିଂ ଲୋଡ୍ ହେଉଛି…',
    'home.doctorBookingsAria': '{doctor}ଙ୍କ ବୁକିଂ',
    'home.bookingCount_one': '{n}ଟି ବୁକିଂ',
    'home.bookingCount_other': '{n}ଟି ବୁକିଂ',
    'home.checkIn': 'ଚେକ୍-ଇନ୍ କରନ୍ତୁ',
    'home.noShow': 'ଆସିଲେ ନାହିଁ',
    'home.bookedOn': '{n} ବୁକ୍ · {date}',
    'home.doctorQueueAria': '{doctor}ଙ୍କ ଧାଡ଼ି',
    'home.completedOf': '{total} ମଧ୍ୟରୁ {done} ସମ୍ପୂର୍ଣ୍ଣ',
    'home.loadingLabBookings': 'ଲ୍ୟାବ୍ ବୁକିଂ ଲୋଡ୍ ହେଉଛି…',
    'home.labCollected': 'ନମୁନା ନିଆଗଲା',
    'home.noLabsOn': '{date}ରେ କୌଣସି ଲ୍ୟାବ୍ ପରୀକ୍ଷା ନାହିଁ',
    'home.labsBookedFromLab': 'ପରୀକ୍ଷା ଲ୍ୟାବ୍ ସ୍କ୍ରିନରୁ ବୁକ୍ ହୁଏ।',
    'home.labTest': 'ଲ୍ୟାବ୍ ପରୀକ୍ଷା',
    'home.labPill.sample_taken': 'ନମୁନା ନିଆଗଲା',
    'home.labPill.completed': 'ସମ୍ପୂର୍ଣ୍ଣ',
    'home.labPill.cancelled': 'ବାତିଲ୍',
    'home.sendTicket': 'ଟିକେଟ୍ ପଠାନ୍ତୁ',
    'home.paidLower': 'ଦେୟ ଦିଆଗଲା',
    'home.unpaidLower': 'ବାକି',

    'home.channel.walk_in': 'ସିଧାସଳଖ କ୍ଲିନିକ୍‌କୁ ଆସି',
    'home.channel.phone': 'ଫୋନ୍ ଦ୍ୱାରା',
    'home.channel.online': 'ଅନଲାଇନ୍',
    'home.cancelReason.patientAsked': 'ରୋଗୀ ବାତିଲ୍ କରିବାକୁ କହିଲେ',
    'home.cancelReason.patientUnwell': 'ରୋଗୀ ଅସୁସ୍ଥ ଅଛନ୍ତି',
    'home.cancelReason.doctorUnavailable': 'ଡାକ୍ତର ଉପଲବ୍ଧ ନାହାଁନ୍ତି',
    'home.cancelReason.clinicClosed': 'ସେଦିନ କ୍ଲିନିକ୍ ବନ୍ଦ',
    'home.cancelReason.mistake': 'ଭୁଲରେ ବୁକ୍ ହେଲା',
    'home.cancelReason.duplicate': 'ଦୁଇଥର ବୁକିଂ',
    'home.cancelReason.other': 'ଅନ୍ୟ',
    'home.cancelWho': '{name}ଙ୍କ ବୁକିଂ ବାତିଲ୍ କରିବେ?',
    'home.cancelNote': '{when}, {doctor}ଙ୍କ ସହ। ସମୟ ଖାଲି ହୋଇଯିବ; ରେକର୍ଡ ରହିବ।',
    'home.sayWhatHappened': 'କ’ଣ ହେଲା ଲେଖନ୍ତୁ',
    'home.cancelAppointment': 'ଆପଏଣ୍ଟମେଣ୍ଟ ବାତିଲ୍ କରନ୍ତୁ',
    'home.couldNotLoadAppt': 'ଆପଏଣ୍ଟମେଣ୍ଟ ଲୋଡ୍ ହୋଇପାରିଲା ନାହିଁ।',
    'home.appointment': 'ଆପଏଣ୍ଟମେଣ୍ଟ',
    'home.notOnListTitle': 'ଏହି ବୁକିଂ ଏହି ତାଲିକାରେ ନାହିଁ',
    'home.notOnListBody': 'ଏହା ଅନ୍ୟ ଦିନର କିମ୍ବା ଅନ୍ୟ ଡାକ୍ତରଙ୍କର ହୋଇପାରେ।',
    'home.backToBookings': 'ବୁକିଂକୁ ଫେରନ୍ତୁ',
    'home.callPatient': 'ରୋଗୀଙ୍କୁ କଲ୍ କରନ୍ତୁ',
    'home.missed': 'ଛାଡ଼ିଗଲା',
    'home.allergyLine': 'ଆଲର୍ଜି: {allergies}',
    'home.bookedBy': 'ବୁକିଂ ମାଧ୍ୟମ',
    'home.payment': 'ଦେୟ',
    'home.paymentRef': 'ଦେୟ ସନ୍ଦର୍ଭ',
    'home.moved': 'ସମୟ ବଦଳିଲା',
    'home.movedNote': 'ଏହି ସମୟ ପୂର୍ବର ଏକ ବୁକିଂର ସ୍ଥାନରେ ଅଛି, ଯାହାର ସମୟ ବଦଳାଯାଇଥିଲା।',
    'home.moveReason': 'ସମୟ ବଦଳାଇବାର କାରଣ',
    'home.cancelReasonLabel': 'ବାତିଲ୍ କରିବାର କାରଣ',
    'home.missedPatient': 'ଏହି ଆପଏଣ୍ଟମେଣ୍ଟର ତାରିଖ ବିତିଗଲା ଏବଂ ଆପଣଙ୍କ ଚେକ୍-ଇନ୍ ହୋଇନଥିଲା। ଯଦି ଏବେ ବି ଡାକ୍ତର ଦେଖାଇବାକୁ ଅଛି, ଏକ ନୂଆ ଆପଏଣ୍ଟମେଣ୍ଟ ବୁକ୍ କରନ୍ତୁ।',
    'home.missedPatientCall': 'ଏହି ଆପଏଣ୍ଟମେଣ୍ଟର ତାରିଖ ବିତିଗଲା ଏବଂ ଆପଣଙ୍କ ଚେକ୍-ଇନ୍ ହୋଇନଥିଲା। ଯଦି ଏବେ ବି ଡାକ୍ତର ଦେଖାଇବାକୁ ଅଛି, ଏକ ନୂଆ ଆପଏଣ୍ଟମେଣ୍ଟ ବୁକ୍ କରନ୍ତୁ, କିମ୍ବା କ୍ଲିନିକ୍‌କୁ {phone}ରେ ଫୋନ୍ କରନ୍ତୁ।',
    'home.livePatient': 'ଏହି ଆପଏଣ୍ଟମେଣ୍ଟ ବଦଳାଇବା କିମ୍ବା ବାତିଲ୍ କରିବା ପାଇଁ ଆପଣଙ୍କ ଆପଏଣ୍ଟମେଣ୍ଟ ତାଲିକାରେ "ସମୟ ବଦଳାନ୍ତୁ" କିମ୍ବା "ବାତିଲ୍ କରନ୍ତୁ" ବ୍ୟବହାର କରନ୍ତୁ।',
    'home.livePatientCall': 'ଏହି ଆପଏଣ୍ଟମେଣ୍ଟ ବଦଳାଇବା କିମ୍ବା ବାତିଲ୍ କରିବା ପାଇଁ ଆପଣଙ୍କ ଆପଏଣ୍ଟମେଣ୍ଟ ତାଲିକାରେ "ସମୟ ବଦଳାନ୍ତୁ" କିମ୍ବା "ବାତିଲ୍ କରନ୍ତୁ" ବ୍ୟବହାର କରନ୍ତୁ, କିମ୍ବା କ୍ଲିନିକ୍‌କୁ {phone}ରେ ଫୋନ୍ କରନ୍ତୁ।',
    'home.closedPatient': 'ଏହି ବୁକିଂର ସ୍ଥିତି: {status}। ଯଦି ଏବେ ବି ଡାକ୍ତର ଦେଖାଇବାକୁ ଅଛି, ଏକ ନୂଆ ଆପଏଣ୍ଟମେଣ୍ଟ ବୁକ୍ କରନ୍ତୁ।',
    'home.dayPassedNoCheckin': 'ଏହି ଦିନ ଚେକ୍-ଇନ୍ ବିନା ବିତିଗଲା।',
    'home.markNoShow': '"ଆସିଲେ ନାହିଁ" ଲେଖନ୍ତୁ',
    'home.closedStaff': 'ଏହି ବୁକିଂର ସ୍ଥିତି: {status}, ଏଥିରେ ଆଉ କିଛି କରାଯାଇପାରିବ ନାହିଁ। ଏହା ବଦଳରେ ଏକ ନୂଆ ଆପଏଣ୍ଟମେଣ୍ଟ ବୁକ୍ କରନ୍ତୁ।',

    'home.couldNotOpenVisit': 'ଏହି ପରିଦର୍ଶନ ଖୋଲାଯାଇପାରିଲା ନାହିଁ।',
    'home.notAvailable': 'ଉପଲବ୍ଧ ନାହିଁ',
    'home.speciality': 'ବିଶେଷଜ୍ଞତା',
    'home.prescription': 'ପ୍ରେସକ୍ରିପସନ୍',
    'home.noRxYet': 'ଏପର୍ଯ୍ୟନ୍ତ କୌଣସି ପ୍ରେସକ୍ରିପସନ୍ ନାହିଁ',
    'home.noRxBody': 'ଡାକ୍ତର ଦସ୍ତଖତ କରିବା ପରେ ଏହା ଏଠାରେ ଦେଖାଯିବ।',
    'home.diagnosis': 'ନିଦାନ',
    'home.daysCount_one': '{n} ଦିନ',
    'home.daysCount_other': '{n} ଦିନ',
    'home.testsAdvised': 'ପରାମର୍ଶିତ ପରୀକ୍ଷା',
    'home.advice': 'ପରାମର୍ଶ',
    'home.followUp': 'ଫଲୋ-ଅପ୍',
    'home.inDays_one': '{n} ଦିନ ପରେ',
    'home.inDays_other': '{n} ଦିନ ପରେ',
    'home.signedBy': '{date}ରେ {doctor} ଦସ୍ତଖତ କରିଛନ୍ତି',
    'home.regNo': 'ପଞ୍ଜୀକରଣ {no}',
    'home.receipt': 'ରସିଦ',
    'home.noPayment': 'କୌଣସି ଦେୟ ଲେଖାଯାଇନାହିଁ',
    'home.noPaymentBody': 'ଡେସ୍କରେ ଫି ଦେବା ପରେ ରସିଦ ଏଠାରେ ଦେଖାଯିବ।',
    'home.payable': 'ଦେୟ ରାଶି',
    'home.paidOn': 'ତାରିଖ',
  },
})
